export const companyHistoryStatuses = {
    closed: 'Fermé',
    current: 'En cours',
}